
import { useState } from "react";
import { subDays } from "date-fns";
import { StudentFilters } from "@/types/student";

export function useStudentFilters() {
  const [filters, setFilters] = useState<StudentFilters>({
    dateRange: {
      from: subDays(new Date(), 30),
      to: new Date()
    },
    courseIds: undefined,
    lastActive: undefined,
    progress: undefined,
    search: undefined
  });

  return { filters, setFilters };
}
